export const PREFIX_SALT = btoa('ovoc');
